<pr-status-label
  class="w-16"
  [dense]="true"
  [label]="statusLabel"
  [color]="statusColor"
/>
